import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { Phone } from './core.module';

export const REFUNDS_API_NAME: string = 'refunds';
export const REFUNDS_API_ENDPOINT: string = environment.API_BASE_PATH + '/refund';

@Injectable({
  providedIn: 'root',
})
export class RefundService {
  read(store_id: string, refund_id: string): Observable<any> {
    const api_name: string = REFUNDS_API_NAME;
    const path: string = `/${refund_id}/store/${store_id}`;
    const init = {
      response: true,
    };
    return from(API.get(api_name, path, init));
  }
}

export interface Refund {
  refund_id?: string;
  store_id?: string;
  store_name?: string;
  order_id?: string;
  buyer_id?: string;
  buyer_sub?: string;
  buyer_firstname?: string;
  buyer_lastname?: string;
  status?: RefundStatus;
  amount?: Amount;
  seller_id?: string;
  seller_firstname?: string;
  seller_lastname?: string;
  seller_email?: string;
  seller_phone?: Phone;
  stripe_pi?: string;
  stripe_pi_client_secret?: string;
  error_code?: string;
  last_error_at?: number;
  error_at?: number;
  succeeded_at?: number;
  failed_at?: number;
  created_at?: number;
  updated_at?: number;
}

export enum RefundStatus {
  pending = 'pending',
  failed = 'failed',
  succeeded = 'succeeded',
}

export class Amount {
  total?: number;
  stripe_fee?: number;
  sp_total_fee?: number;
  sp_net_fee?: number;
  net?: number;
  collected?: number;
  refunded?: number;
  currency?: Currency;
}

export enum Currency {
  eur = 'eur',
  dol = 'dol',
}
